import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

// ==================== IMSI Groups ====================

export const getImsiGroups = async (token) => {
    log("welcome in getImsiGroups from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getImsiGroupsApi', { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in getImsiGroups", err)
        return { error: true, message: "Error loading IMSI groups" }
    }
}

export const createImsiGroup = async (token, name, description, imsiIds = [], clientId = null) => {
    log("welcome in createImsiGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const data = { name, description, imsi_ids: imsiIds }
        if (clientId) data.client_id = clientId
        const result = await axios.post(BASE_URL + '/home/createImsiGroupApi',
            data, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in createImsiGroup", err)
        return { error: true, message: "Error creating IMSI group" }
    }
}

export const updateImsiGroup = async (token, groupId, name, description, clientId = null) => {
    log("welcome in updateImsiGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const data = { group_id: groupId, name, description }
        if (clientId) data.client_id = clientId
        const result = await axios.put(BASE_URL + '/home/updateImsiGroupApi',
            data, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in updateImsiGroup", err)
        return { error: true, message: "Error updating IMSI group" }
    }
}

export const deleteImsiGroup = async (token, groupId) => {
    log("welcome in deleteImsiGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.delete(BASE_URL + '/home/deleteImsiGroupApi',
            { headers: getHeaders(token), params: { group_id: groupId } })
        return result.data
    } catch (err) {
        log("Error in deleteImsiGroup", err)
        return { error: true, message: "Error deleting IMSI group" }
    }
}

export const addImsisToGroup = async (token, groupId, imsiIds) => {
    log("welcome in addImsisToGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/addImsisToGroupApi',
            { group_id: groupId, imsi_ids: imsiIds }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in addImsisToGroup", err)
        return { error: true, message: "Error adding IMSIs to group" }
    }
}

export const removeImsisFromGroup = async (token, groupId, simIds = [], imsiIds = []) => {
    log("welcome in removeImsisFromGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/removeImsisFromGroupApi',
            { group_id: groupId, sim_ids: simIds, imsi_ids: imsiIds }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in removeImsisFromGroup", err)
        return { error: true, message: "Error removing IMSIs from group" }
    }
}

export const getImsiGroupMembers = async (token, groupId, page = 1, perPage = 20) => {
    log("welcome in getImsiGroupMembers from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getImsiGroupMembersApi',
            { headers: getHeaders(token), params: { group_id: groupId, page, per_page: perPage } })
        return result.data
    } catch (err) {
        log("Error in getImsiGroupMembers", err)
        return { error: true, message: "Error loading IMSI group members" }
    }
}

// ==================== MSISDN Groups ====================

export const getMsisdnGroups = async (token) => {
    log("welcome in getMsisdnGroups from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getMsisdnGroupsApi', { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in getMsisdnGroups", err)
        return { error: true, message: "Error loading MSISDN groups" }
    }
}

export const createMsisdnGroup = async (token, name, description, msisdnIds = [], clientId = null) => {
    log("welcome in createMsisdnGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const payload = { name, description, msisdn_ids: msisdnIds }
        if (clientId) payload.client_id = clientId
        const result = await axios.post(BASE_URL + '/home/createMsisdnGroupApi',
            payload, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in createMsisdnGroup", err)
        return { error: true, message: "Error creating MSISDN group" }
    }
}

export const updateMsisdnGroup = async (token, groupId, name, description) => {
    log("welcome in updateMsisdnGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.put(BASE_URL + '/home/updateMsisdnGroupApi',
            { group_id: groupId, name, description }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in updateMsisdnGroup", err)
        return { error: true, message: "Error updating MSISDN group" }
    }
}

export const deleteMsisdnGroup = async (token, groupId) => {
    log("welcome in deleteMsisdnGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.delete(BASE_URL + '/home/deleteMsisdnGroupApi',
            { headers: getHeaders(token), params: { group_id: groupId } })
        return result.data
    } catch (err) {
        log("Error in deleteMsisdnGroup", err)
        return { error: true, message: "Error deleting MSISDN group" }
    }
}

export const addMsisdnsToGroup = async (token, groupId, msisdnIds) => {
    log("welcome in addMsisdnsToGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/addMsisdnsToGroupApi',
            { group_id: groupId, msisdn_ids: msisdnIds }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in addMsisdnsToGroup", err)
        return { error: true, message: "Error adding MSISDNs to group" }
    }
}

export const removeMsisdnsFromGroup = async (token, groupId, msisdnIds) => {
    log("welcome in removeMsisdnsFromGroup from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/removeMsisdnsFromGroupApi',
            { group_id: groupId, msisdn_ids: msisdnIds }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in removeMsisdnsFromGroup", err)
        return { error: true, message: "Error removing MSISDNs from group" }
    }
}

export const getMsisdnGroupMembers = async (token, groupId, page = 1, perPage = 20) => {
    log("welcome in getMsisdnGroupMembers from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getMsisdnGroupMembersApi',
            { headers: getHeaders(token), params: { group_id: groupId, page, per_page: perPage } })
        return result.data
    } catch (err) {
        log("Error in getMsisdnGroupMembers", err)
        return { error: true, message: "Error loading MSISDN group members" }
    }
}

// ==================== Bulk Operations ====================

export const getAllFilteredSimIds = async (token, filters = {}) => {
    log("welcome in getAllFilteredSimIds from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getAllFilteredSimIdsApi',
            { headers: getHeaders(token), params: filters })
        return result.data
    } catch (err) {
        log("Error in getAllFilteredSimIds", err)
        return { error: true, message: "Error loading filtered SIM IDs" }
    }
}

export const getAllFilteredMsisdnIds = async (token, filters = {}) => {
    log("welcome in getAllFilteredMsisdnIds from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/getAllFilteredMsisdnIdsApi',
            { headers: getHeaders(token), params: filters })
        return result.data
    } catch (err) {
        log("Error in getAllFilteredMsisdnIds", err)
        return { error: true, message: "Error loading filtered MSISDN IDs" }
    }
}

export const bulkSuspendSims = async (token, simIds) => {
    log("welcome in bulkSuspendSims from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/bulkSuspendSimsApi',
            { sim_ids: simIds }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in bulkSuspendSims", err)
        return { error: true, message: "Error in bulk suspend" }
    }
}

export const bulkReactivateSims = async (token, simIds) => {
    log("welcome in bulkReactivateSims from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/bulkReactivateSimsApi',
            { sim_ids: simIds }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in bulkReactivateSims", err)
        return { error: true, message: "Error in bulk reactivate" }
    }
}

export const bulkTerminateSims = async (token, simIds) => {
    log("welcome in bulkTerminateSims from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/bulkTerminateSimsApi',
            { sim_ids: simIds }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in bulkTerminateSims", err)
        return { error: true, message: "Error in bulk terminate" }
    }
}

export const bulkProvisionSims = async (token, simIds) => {
    log("welcome in bulkProvisionSims from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/bulkProvisionSimsApi',
            { sim_ids: simIds }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in bulkProvisionSims", err)
        return { error: true, message: "Error in bulk provision" }
    }
}

export const bulkMoveImsisToSubclient = async (token, imsiIds, targetClientId, options = {}) => {
    log("welcome in bulkMoveImsisToSubclient from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const payload = {
            imsi_ids: imsiIds,
            target_client_id: targetClientId
        }

        // Add optional delivery parameters
        if (options.needDelivery !== undefined) {
            payload.need_delivery = options.needDelivery
        }
        if (options.deliveryTypeId) {
            payload.delivery_type_id = options.deliveryTypeId
        }
        if (options.deliveryDetails) {
            payload.delivery_details = options.deliveryDetails
        }

        const result = await axios.post(BASE_URL + '/home/bulkMoveImsisToSubclientApi',
            payload, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in bulkMoveImsisToSubclient", err)
        return { error: true, message: "Error in bulk move" }
    }
}

const useGroupsAPI = () => {
    return {
        error,
        // IMSI Groups
        getImsiGroups,
        createImsiGroup,
        updateImsiGroup,
        deleteImsiGroup,
        addImsisToGroup,
        removeImsisFromGroup,
        getImsiGroupMembers,
        // MSISDN Groups
        getMsisdnGroups,
        createMsisdnGroup,
        updateMsisdnGroup,
        deleteMsisdnGroup,
        addMsisdnsToGroup,
        removeMsisdnsFromGroup,
        getMsisdnGroupMembers,
        // Bulk Operations
        getAllFilteredSimIds,
        getAllFilteredMsisdnIds,
        bulkSuspendSims,
        bulkReactivateSims,
        bulkTerminateSims,
        bulkProvisionSims,
        bulkMoveImsisToSubclient
    }
}

export default useGroupsAPI
